import { useTranslation } from 'react-i18next';
import { Button } from './Button';

export function LanguageSwitcher() {
    const { i18n } = useTranslation();

    // Fallback si i18n no está configurado
    const currentLanguage = i18n?.language || 'en';
    const isSpanish = currentLanguage.startsWith('es');

    const toggleLanguage = () => {
        if (!i18n) return;
        const newLang = isSpanish ? 'en' : 'es';
        i18n.changeLanguage(newLang);
    };

    return (
        <Button
            variant="plain"
            size="sm"
            onClick={toggleLanguage}
            className="font-medium"
        >
            {isSpanish ? 'EN' : 'ES'}
        </Button>
    );
}
